<template>
    <div class="list-categories" id="list_categories">
        <v-list flat :class="getListClasses()">
            <v-list-item-group>
                <template v-for="(category, index) in categoriesList">
                    <category v-if="category.subcategories" :key="index" :title="category.title" :icon="category.icon" :expanded="category.expanded" :active="category.active" @selected-category="category.expanded = !category.expanded"> </category>

                    <template v-else>
                        <inertia-link v-if="category.title != 'Corporate'" :key="index" :href="category.url" class="no-underline">
                            <category :title="category.title" :icon="category.icon" :active="category.active"></category>
                        </inertia-link>
                        <category v-else :key="index" :title="category.title" :icon="category.icon" :active="category.active"></category>
                    </template>

                    <template v-if="category.expanded">
                        <div v-for="subcategory in computedSubcategories(category)" :key="subcategory.title" :href="subcategory.url">
                            <a v-if="subcategory.isDialog" @click="openDialog(subcategory)"   target="_blank" class="no-underline">
                                <category :small="true" classes="pr-0" :title="subcategory.title" :active="subcategory.active"> </category>
                            </a>
                            <inertia-link @click="closedDrawer" @touchend="closedDrawer" v-else-if="subcategory.url && subcategory.url[0] == '/'" :key="index" :href="subcategory.url" class="category-link no-underline">
                                <category :small="true" classes="pr-1" :title="subcategory.title" :active="subcategory.active"> </category>
                            </inertia-link>
                            <a v-else :href="tUrl(subcategory.url)" :data-cy="subcategory.title == 'Logistica Sustentável' ? 'sidebar-corporate-logistics-link' : ''" target="_blank" class="no-underline">
                                <category :small="true" classes="pr-2" :title="subcategory.title" :active="subcategory.active"> </category>
                            </a>
                        </div>

                        <v-spacer :key="category.title + index" class="mb-4"></v-spacer>
                    </template>

                    <v-divider v-if="index < categories.length - 1" :key="`${index}-divider`" class="mx-4" style="border-color: rgba(196, 196, 196, 0.2); margin-top: -5px; margin-bottom: -5px"></v-divider>
                </template>
            </v-list-item-group>
        </v-list>

        <price-table-request v-if="isPriceTableRequestDialogOpen" :value="isPriceTableRequestDialogOpen" @onCancel="isPriceTableRequestDialogOpen = false"> </price-table-request>
        <campaign-pdf-dialog v-if="isCampaignPdfDialogOpen" :value="isCampaignPdfDialogOpen" @onCancel="isCampaignPdfDialogOpen = false"> </campaign-pdf-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import Category from './Category';

export default {
    components: { Category },

    props: {
        categories: Array,

        listClass: {
            type: String,
            default: '',
        },

        isScrollable: {
            type: Boolean,
            default: true,
        },

        categoriesListHeight: {
            type: String,
            default: '42vh',
        },
    },
    data: () => ({
        isPriceTableRequestDialogOpen: false,
        isCampaignPdfDialogOpen: false,
        isIpad:false,
        pdfUrl:null
    }),
    watch: {
        'userStore.user': {
            handler: function () {
                this.updateCategories(window.location.pathname);
            },
        },

        '$page.url': {
            handler: function (url) {
                this.updateCategories(url);
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useAppStore),
        categoriesList(){
          //console.log('categoriesList',this.categories)
          return this.categories
        }
    },
    mounted(){
      setTimeout(()=>{
        this.isIpad = this.isIOS()
      },500)
    },
    methods: {
        closedDrawer(){
            setTimeout(()=>{
                this.appStore.setNavDrawer(false)
            },600)
            //window.EventBus.$emit('close-nv-drawer')
        },
        computedSubcategories(category) {
            return category.subcategories?.filter((category) => !category.hidden);
        },
        openDialog(subCategory) {
            if (subCategory.title == 'Pedido de Tabela de Preços') {
                this.isPriceTableRequestDialogOpen = true;
            }
            if (subCategory.title == 'Informativo') {
                if(!this.isIpad)
                   this.isCampaignPdfDialogOpen = true;
                else{
                    axios.get('/api/campaigns/pdf').then((response) => {
                        if (response.data) {
                            this.pdfUrl = response.data;
                            axios({
                                url: this.pdfUrl,
                                method: 'GET',
                                responseType: 'blob',
                            }).then((response) => {
                                let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                                let fileLink = document.createElement('a');

                                fileLink.href = fileURL;
                                const splitPath = this.pdfUrl.split('/');
                                fileLink.download = splitPath[splitPath.length - 1];

                                fileLink.click();
                            });
                        }
                    });
                }
            }
        },
        base64ToBlob( base64, type = "application/octet-stream" ) {
            const binStr = atob( base64 );
            const len = binStr.length;
            const arr = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                arr[ i ] = binStr.charCodeAt( i );
            }
            return new Blob( [ arr ], { type: type } );
        },

        updateCategories(url) {
            // @Note: We want to hide previously clicked categories that are not active.
            for (const category of this.categories) {
                if (category.subcategories) {
                    category.expanded = false;
                }

                for (const subcategory of category.subcategories ?? []) {
                    subcategory.active = false;
                }
            }

            // @Note: We want to highlight the current 'active' category (i.e. the page that the user is currently seeing).
            for (const category of this.categories) {
                // We'll want to exclude the content of any queries (e.g. the search in the dashboard)
                //  so that the current URL is normalized with the URLs that are available in the categories.
                url = url.split('?')[0];

                if (category.url == url) {
                    category.active = true;
                }

                for (const subcategory of category.subcategories ?? []) {
                    // If the current route matches a subcategory, we should also expand the parent category.
                    if (subcategory.url == url) {
                        category.active = subcategory.active = true;
                        category.expanded = true;
                    }
                }
            }
        },

        getListClasses() {
            let scrollClass = this.isScrollable ? 'list_content_scroll_categories ' : ' ';

            return scrollClass + this.listClass;
        },
    },
};
</script>

<style scoped>
.list_content_scroll_categories {
    overflow-y: auto;
    overflow-x: hidden;
    padding-left: -16px !important;
    padding-right: -16px !important;
}
</style>
